<template>
    <div class="input-group-three">
        <slot/>
    </div>
</template>

<script>
    export default {
        name: "FormGroupThree"
    }
</script>

<style lang="scss" scoped>
    .input-group-three {
        @apply flex flex-row items-start flex-wrap w-auto;

        @screen md {
            @apply -mx-2;
        }

        .input-group {
            @apply w-full px-0 mb-6;

            @screen md {
                @apply w-1/2 px-2;
            }

            @screen xl {
                @apply w-1/3;
            }
        }
    }
</style>